import { render, staticRenderFns } from "./MainSide.vue?vue&type=template&id=5afe26f8&scoped=true&"
import script from "./MainSide.vue?vue&type=script&lang=js&"
export * from "./MainSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afe26f8",
  null
  
)

export default component.exports